// extracted by mini-css-extract-plugin
export default {"registerContainer":"RegisterPage_registerContainer__gxvxk"};